import { useState } from "react";
import { Link } from "react-router-dom";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").trim();

export default function SignupPage() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [alreadyRegistered, setAlreadyRegistered] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setAlreadyRegistered(false);

    try {
      console.log("Submitting email:", email);
      console.log("Backend URL:", BACKEND_URL);

      if (!BACKEND_URL) {
        throw new Error("Backend URL is not set. Please check your environment variables.");
      }

      const response = await fetch(`${BACKEND_URL}/api/email/email-signup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        let errorData = {};
        try {
          errorData = await response.json();
          console.log("Error response JSON:", errorData);
        } catch {
          const text = await response.text();
          errorData.detail = text || "Unknown error";
          console.log("Error response text:", text);
        }

        if (
          errorData.detail &&
          errorData.detail.toLowerCase().includes("already")
        ) {
          setAlreadyRegistered(true);
          setError(""); // Clear other errors if already registered
        } else {
          setError(errorData.detail || "Signup failed. Please try again.");
        }
        return;
      }

      // Success
      setSubmitted(true);
    } catch (err) {
      console.error("Fetch error:", err);
      setError(err.message || String(err));
    }
  };

  return (
    <div className="min-h-screen bg-[#1a4d42] flex items-center justify-center px-6 py-12">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,_rgba(67,179,126,0.15),_transparent_40%),radial-gradient(circle_at_top_right,_rgba(59,130,246,0.1),_transparent_35%)]" />
      <div className="relative w-full max-w-md">
        <div className="rounded-[2rem] border border-white/10 bg-[#173a32] p-8 shadow-2xl shadow-black/20">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-black text-white mb-2">Get Started</h1>
            <p className="text-slate-300 text-sm">Enter your email to get your login details</p>
          </div>
          {!submitted ? (
            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                type="email"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full px-4 py-3 rounded-lg border border-white/20 bg-white/5 text-white placeholder-slate-400 focus:outline-none focus:border-emerald-400 focus:bg-white/10 transition"
              />

              <button
                type="submit"
                className="w-full py-3 px-4 rounded-lg bg-[#8ff0b3] text-[#0f2b24] font-bold text-base hover:bg-[#b3f7ca] transition shadow-lg shadow-black/20"
              >
                Submit
              </button>
            </form>
          ) : null}

          {alreadyRegistered && (
            <p className="mt-4 p-3 rounded-lg bg-amber-500/20 border border-amber-500/30 text-amber-200 text-sm font-medium text-center">
              Looks like your email is already registered.{" "}
              <Link to="/login" className="font-semibold text-emerald-300 hover:text-emerald-200 transition">
                Login here
              </Link>
            </p>
          )}

          {error && !alreadyRegistered && (
            <p className="mt-4 p-3 rounded-lg bg-red-500/20 border border-red-500/30 text-red-200 text-sm font-medium text-center">
              {error}
            </p>
          )}
          {submitted && (
            <div className="text-center space-y-3">
              <p className="mt-4 p-3 rounded-lg bg-emerald-500/20 border border-emerald-500/30 text-emerald-200 text-sm font-medium">
                Check your mailbox!
              </p>
              <p className="text-slate-300 text-sm">
                We've sent your login details to <strong>{email}</strong>.
                <br />
                Please check your inbox and spam folder.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
